export default function lerpColor(t, c1, c2) {
  t = Math.max(0, Math.min(1, t))

  const rgb1 = c1.match(/\w\w/g).map((c) => parseInt(c, 16))
  const rgb2 = c2.match(/\w\w/g).map((c) => parseInt(c, 16))

  const rgb = rgb1.map((v, i) => Math.round(v + (rgb2[i] - v) * t))

  return '#' + rgb.map((c) => c.toString(16).padStart(2, '0')).join('')
}
